import React from 'react';
import { BATTLES_STANDING_TYPE } from 'shared/screens/Battles/constants';
import styled from 'styled-components';
import { truncatePlayerName } from '../../../utils';

const CollectTabsScreen = ({ standings }) => {
  return (
    <Table>
      {standings.map((s, i) => (
        <TableRow key={i} $isPlayer={s.type === BATTLES_STANDING_TYPE.PLAYER}>
          <TableDataCell>{s.rank}</TableDataCell>
          <TableDataCell>{truncatePlayerName(s.name)}</TableDataCell>
          <TableDataCell>{s.points}</TableDataCell>
        </TableRow>
      ))}
    </Table>
  );
};

export default CollectTabsScreen;

const Table = styled.table`
  width: 100%;
`;

const TableRow = styled.tr`
  position: relative;
  overflow: hidden;
  color: ${({ $isPlayer }) => ($isPlayer ? 'black' : 'white')};
  background: ${({ $isPlayer }) => ($isPlayer ? 'rgb(255, 192, 0)' : 'transparent')};

  & > td:first-child {
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
  }
  & > td:last-child {
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
  }
`;

const TableDataCell = styled.td`
  text-align: center;
  font-weight: 600;
  font-size: 0.95vw;
  width: 33.33%;
  white-space: nowrap;
  ${({ theme }) => theme.breakpoints.down('md') && `font-size: 0.85vw;`}
  ${({ theme }) => theme.platform('android') && theme.screens.device('mobile-standalone') && `font-size: 0.9vw;`}
`;

